/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Unlock_SuccessInputs */



/**
* | output |
* | --- |
* | "Event group has been unlocked." |
*
* @param {Event_Group_Options_Unlock_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_unlock_success = /** @type {((inputs?: Event_Group_Options_Unlock_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Unlock_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Event group has been unlocked.")
	return /** @type {LocalizedString} */ ("Event group has been unlocked.")
});